<template>
  <div class="pos-rel screen-height photos-docu" style="padding-inline:100px; padding-top: 5px; overflow-x:hidden" v-show="this.$store.state.photo.isMainView" id="simple_photo_checkbox" :class="{ 'bottom_nav_open': this.$store.state.photo.isBottomNav,'photos-main-view': isMainView }">
    <div class="position-relative">
      <a download href="" target="_blank" class="d-none" id="download-photo"></a>
      <div v-if="this.$store.state.photo.filtered <= 0" class="py-2 text-center">
        Keine Fotos vorhanden
      </div>
<!--      <div class="pagination-top py-1" v-if="$store.state.photo.TPage > '1'">-->

<!--        <div class="row">-->
<!--          <div class="col-md-3">-->
<!--            <span class=" font-10" v-if="$store.state.photo.LEnd < $store.state.photo.filtered">{{$store.state.photo.LStart}} bis {{($store.state.photo.LEnd )}} von  {{($store.state.photo.filtered)}} Fotos</span>-->
<!--            <span class=" font-10" v-if="$store.state.photo.LEnd > $store.state.photo.filtered">{{$store.state.photo.LStart}} bis {{($store.state.photo.filtered )}} von  {{($store.state.photo.filtered)}} Fotos</span>-->
<!--          </div>-->
<!--          <div class="col-md-6">-->

<!--            <keep-alive>-->
<!--              <sliding-pagination-->
<!--                :current="$store.state.photo.page"-->
<!--                :total="$store.state.photo.TPage"-->
<!--                @page-change="pageChangeHandler"-->
<!--                :classMap='{-->
<!--                   "componentClass": "pagination-bottom border-top pt-2",-->
<!--                   "list": "pagination justify-content-center pagination-sm",-->
<!--                   "element": "page-item ",-->
<!--                   "elementDisabled": "disabled",-->
<!--                   "elementActive": "active",-->
<!--                   "page": "page-link"  }'/>-->
<!--            </keep-alive>-->
<!--          </div>-->
<!--          <div class="col-md-3"></div>-->
<!--        </div>-->



<!--      </div>-->
      <div class="row mt-2 main-photos-page" id="simple_photo" :class="{ isBottomNav: this.$store.state.photo.isBottomNav }">
<!--        <PhotoModal v-bind:photoIDCollection='photos'></PhotoModal>-->
        <div class="col-xl-2 col-lg-3 col-md-4 pl-0"  v-for="(photo, index) in photos" :key="index">

          <div class="simple-photo" @click="setClickIndex($event, index)" v-on:click.shift="selectMultiple($event, index)" :data-index="index">
<!--            <Popup :photo="photo" :creators="creators" :isSelecteAble="isSelecteAble"></Popup>-->
<!--            <input type="checkbox" v-model="selectedImages" :id="'cb'+photo.pdphotoid"  :value="photo" :ref="photo.pdphotoid" :disabled="!isSelecteAble"/>-->
<!--            <label :for="'cb'+photo.pdphotoid">-->
<!--              <div data-aspect-ratio="4:3">-->
<!--                  <div  v-bind:style="{ 'backgroundImage': 'url(' + photo.src + ')' }"-->
<!--                        :alt="photo.origname"-->
<!--                        :data-value="photo.pdphotoid"-->
<!--                        :data-index="index"-->
<!--                        :data-photoid="photo.pdphotoid"-->
<!--                        :data-runid="photo.runid"-->
<!--                        :photo_id='photo.id'-->
<!--                        @dblclick="showModal(photo,photos)"-->
<!--                        ref="img"-->
<!--                  ></div>-->
<!--              </div>-->
<!--            </label>-->
            <!--
            <div class="has-gps" v-if="photo.exifhasgps"><img src="@/assets/images/has-gps.png" /></div>
            <div class="has-planlocation" v-if="photo.inplan"><img src="@/assets/images/has-planlocation.png" /></div>
            <div class="has-tags" v-if="photo.params.length"><img src="@/assets/images/has-tags.png" /></div>
            <div class="has-description" v-if="photo.description"><img src="@/assets/images/has-description.png" /></div>
            <div class="has-memos" v-if="photo.memos.length"><img src="@/assets/images/has-memos.png" /></div>
            -->
            <photodetail :imgdata="photo" :index="index" ></photodetail>
          </div>
        </div>
      </div>


      <div class="row mr-0 shadow-sm border  pl-0 position-sticky bg-white border-top pt-1 text-center pagination"  v-if="$store.state.photo.TPage > '1'" style="bottom: 0">
          <div class="col-md-3 text-left pr-0 pt-1">
            <span class="font13" v-if="$store.state.photo.LEnd < $store.state.photo.filtered">{{$store.state.photo.LStart}} bis {{($store.state.photo.LEnd )}} von  {{($store.state.photo.filtered)}} Fotos</span>
            <span class="font13" v-if="$store.state.photo.LEnd > $store.state.photo.filtered">{{$store.state.photo.LStart}} bis {{($store.state.photo.filtered )}} von  {{($store.state.photo.filtered)}} Fotos</span>
          </div>
          <div class="col-md-6 main-photos-pagination">
            <keep-alive>
              <sliding-pagination
                :current="$store.state.photo.page"
                :total="$store.state.photo.TPage"
                @page-change="pageChangeHandler"
                :classMap='{
                   "componentClass": "pagination-bottom border-top pt-2",
                   "list": "pagination justify-content-center pagination-sm",
                   "element": "page-item ",
                   "elementDisabled": "disabled",
                   "elementActive": "active",
                   "page": "page-link"  }'/>
            </keep-alive>
          </div>
          <div class="col-md-3"></div>
      </div>

    </div>
  </div>
</template>

<script>
import Popup from './infoPopup'
import SlidingPagination from 'vue-sliding-pagination'
import photodetail from './subitems/photodetail'
// import PhotoModal from '../../projects/PhotoModal'
export default {
  name: 'Main',
  props: ['searchString'],
  data () {
    return {
      plans: [],
      selections: [],
      tags: [],
      startDate: '',
      endDate: '',
      meta: [],
      lastimageindex: 0,
      getImagesUrl: process.env.VUE_APP_BASE_URL + 'project/' + this.$route.params.id + '/photos/getlist'
    }
  },
  async mounted () {
    await this.$store.dispatch("getProjectUsers",this.$route.params.id);
  },
  components: {
    Popup,
    SlidingPagination,
    photodetail
    // PhotoModal
  },
  computed: {
    photos () {
      return this.$store.state.photo.photos
    },
    isMainView() {
     return this.$store.state.photo.isMainView;
    },
    creators () {
      return this.$store.state.creators
    },

    selectedImages: {
      get () {
        return this.$store.state.photo.selectedPhotos
      },
      set (val) {
        this.$store.commit('setSelectedPhotos', val)
      }
    },

    isSelecteAble () {
      return this.$store.state.photo.isBottomNav
    }
  },
  methods: {
    // ScrollZoom(container,max_scale,factor){
    //   var target = container.children().first()
    //   var size = {w:target.width(),h:target.height()}
    //   var pos = {x:0,y:0}
    //   var zoom_target = {x:0,y:0}
    //   var zoom_point = {x:0,y:0}
    //   var scale = 1
    //   target.css('transform-origin','0 0')
    //   target.on("mousewheel DOMMouseScroll",scrolled)
    //
    //   function scrolled(e){
    //
    //     console.log('ScrollZoom (MAIN)', container,max_scale,factor)
    //     var offset = container.offset()
    //     zoom_point.x = e.pageX - offset.left
    //     zoom_point.y = e.pageY - offset.top
    //
    //     e.preventDefault();
    //     var delta = e.delta || e.originalEvent.wheelDelta;
    //     if (delta === undefined) {
    //       //we are on firefox
    //       delta = e.originalEvent.detail;
    //     }
    //     delta = Math.max(-1,Math.min(1,delta)) // cap the delta to [-1,1] for cross browser consistency
    //
    //     console.log('ScrollZoom (MAIN)', container,max_scale,factor, offset.left,offset.top, e.pageX, e.pageY, delta)
    //
    //
    //     // determine the point on where the slide is zoomed in
    //     zoom_target.x = (zoom_point.x - pos.x)/scale
    //     zoom_target.y = (zoom_point.y - pos.y)/scale
    //
    //     // apply zoom
    //     scale += delta*factor * scale
    //     scale = Math.max(1,Math.min(max_scale,scale))
    //
    //     // calculate x and y based on zoom
    //     pos.x = -zoom_target.x * scale + zoom_point.x
    //     pos.y = -zoom_target.y * scale + zoom_point.y
    //
    //
    //     // Make sure the slide stays in its container area when zooming out
    //     if(pos.x>0)
    //       pos.x = 0
    //     if(pos.x+size.w*scale<size.w)
    //       pos.x = -size.w*(scale-1)
    //     if(pos.y>0)
    //       pos.y = 0
    //     if(pos.y+size.h*scale<size.h)
    //       pos.y = -size.h*(scale-1)
    //
    //     console.log('POS', pos)
    //
    //     update()
    //   }
    //
    //   function update(){
    //     target.css('transform','translate('+(pos.x)+'px,'+(pos.y)+'px) scale('+scale+','+scale+')')
    //   }
    // },
    // async getfileImage_xxl (photo) {
    //   //let url = process.env.VUE_APP_BASE_URL + 'getfile/photo/' + photo.id + '/2000x2000/',
    //   //let url = process.env.VUE_APP_BASE_URL + value.path + '&type=XL&token=' + localStorage.sessiontoken
    //   let url = `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${photo.pdprojectid}&id=${photo.pdphotoid}&type=l&token=${localStorage.sessiontoken}`
    //   await fetch(url,
    //     {
    //       headers: {
    //         apitoken: localStorage.apikey,
    //         deviceid: localStorage.deviceid
    //       }
    //     }
    //   )
    //     .then(response => response.blob())
    //     .then(response => {
    //       let reader = new FileReader()
    //       reader.readAsDataURL(response)
    //       reader.onload = function () {
    //         let xxl_photo = reader.result
    //         this.neuesBase = xxl_photo
    //         /** Kann es aktuell nur mit Jquery lösen **/
    //         $('.xxl_photo_view').prop('src', xxl_photo)
    //         $('.xxl_photo_view').prop('id', photo.pdphotoid)
    //       }
    //     })
    // },
    showModal (photoXXL, photosXXL) {
      // this.getfileImage_xxl(photoXXL)
      // this.ScrollZoom($('#image_container'),4,0.25);
      /** Here the Code from the API Picture in Full Size **/
      // Enable the Modal - View if clicked on Picture
      // $('#imagemodal').modal('show')
      // this.$store.state.photo.currentModalPhoto = photoXXL
      console.log('showModal in Main.vue')
      this.$parent.loadXXL(photoXXL)
    },

    getImageMain () {
      this.photos = this.$store.state.photo.photos
    },
    pageChangeHandler (selectedPage) {
      this.$store.state.photo.page = selectedPage
      this.$root.$emit('pageChangeHandler', selectedPage)
    },

    setClickIndex (event, index) {
      if(!event.shiftKey) {
        this.lastimageindex = index
      }
    },

    // Select MultiPhotos On Click Of Shift + Clicked
    selectMultiple (event, last) {
      let obj = this
      if (this.isSelecteAble) {
        let start = this.lastimageindex
        let index = event.target.getAttribute('data-index')
        index = last
        for (let i = start; i < index; i++) {
          if (obj.selectedImages.findIndex((item) => item.pdphotoid === obj.photos[i].pdphotoid) < 0) {
            obj.selectedImages.push(obj.photos[i])
          }
        }
      }
    }

  }

}
</script>
<style>
.main-photos-pagination .pagination-sm .page-link{
  font-size: .94rem;
  padding-inline: 10px
}
</style>



// WEBPACK FOOTER //
// src/components/photo/components/Main.vue